"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var press_1 = require("../../utils/shopify-graphql/press");
var path_1 = require("../../utils/shopify/path");
var Press = function () {
    var _a = (0, hooks_1.useState)(null), pressData = _a[0], setPressData = _a[1];
    (0, hooks_1.useEffect)(function () {
        var url = window.location;
        var handle = url.pathname.split('/')[2];
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, press_1.getPressData)(handle, pathType)
            .then(function (data) {
            if (data === null || data === void 0 ? void 0 : data.value) {
                var pressData_1 = JSON.parse(data.value);
                setPressData(pressData_1);
            }
        })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (pressData) {
        return ((0, preact_1.h)("div", { class: "press-section__container" }, pressData.data.map(function (link) { return ((0, preact_1.h)("img", { alt: "", class: "press-section__image", key: link, src: link })); })));
    }
    else {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
};
exports.default = Press;
